// Global Instructions Rule Applied!
//
// Configuration → Deal Execution admin models: the deal-type → execution
// pipeline mapping rows and the per-stage checklist items.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const DealExecutionMappingRowSchema = z
  .object({
    deal_type_id: z.string(),
    deal_type__label: z.string().nullish(),
    deal_execution_pipeline_map__id: z.string().nullish(),
    pipeline_id: z.string().nullish(),
    pipelines__name: z.string().nullish()
  })
  .strict()

export type DealExecutionMappingRow = z.infer<typeof DealExecutionMappingRowSchema>

export function validateDealExecutionMappingRow(
  data: unknown,
  options?: { isArray?: boolean }
): DealExecutionMappingRow | DealExecutionMappingRow[] {
  try {
    return validateWithZodSchema(
      DealExecutionMappingRowSchema,
      data,
      'deal execution mapping row',
      options
    ) as DealExecutionMappingRow | DealExecutionMappingRow[]
  } catch (e) {
    throw new Error(`Deal execution mapping validation failed: ${e}`)
  }
}

export const StageChecklistAdminRowSchema = z
  .object({
    stage_checklist_items__id: z.string(),
    stage_checklist_items__label: z.string().nullish(),
    stage_checklist_items__sequence: z.number().nullish(),
    stage_checklist_items__active: z.boolean().nullish(),
    pipeline_config_id: z.string(),
    pipeline_config__sequence_kb: z.number().nullish(),
    pipelines__id: z.string().nullish(),
    pipelines__name: z.string().nullish(),
    pipeline_stages__name: z.string().nullish()
  })
  .strict()

export type StageChecklistAdminRow = z.infer<typeof StageChecklistAdminRowSchema>

export function validateStageChecklistAdminRow(
  data: unknown,
  options?: { isArray?: boolean }
): StageChecklistAdminRow | StageChecklistAdminRow[] {
  try {
    return validateWithZodSchema(
      StageChecklistAdminRowSchema,
      data,
      'stage checklist admin row',
      options
    ) as StageChecklistAdminRow | StageChecklistAdminRow[]
  } catch (e) {
    throw new Error(`Stage checklist admin validation failed: ${e}`)
  }
}
